import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

export default function ServicesHero() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 120);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative min-h-[82vh] flex items-end overflow-hidden bg-luxury-black">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ad31dbdc0d49c558d1dee66d3de0c281.jpg"
          alt="HVAC professional service"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/90" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-black/30" />
      </div>
      <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse 50% 60% at 20% 70%, rgba(201,169,110,0.12) 0%, transparent 65%)' }} />
      <div className="absolute top-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent, rgba(201,169,110,0.30), transparent)' }} />

      <div className={`relative w-full max-w-[1500px] mx-auto px-6 lg:px-14 pb-20 pt-44 transition-all duration-900 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 mb-7">
          <Link to="/" className="font-caps text-[10px] tracking-[0.2em] uppercase text-white/35 hover:text-luxury-gold/70 transition-colors cursor-pointer whitespace-nowrap">Home</Link>
          <span className="text-white/20 text-xs">/</span>
          <span className="font-caps text-[10px] tracking-[0.2em] uppercase text-luxury-gold/65 whitespace-nowrap">Services</span>
        </div>

        <div className="flex items-center gap-3 mb-6">
          <div className="w-8 h-0.5 bg-luxury-gold" />
          <span className="font-caps text-[10px] tracking-[0.3em] uppercase text-luxury-gold/60">GTA HVAC Specialists</span>
        </div>

        <h1 className="font-serif text-5xl sm:text-6xl lg:text-8xl text-white leading-none mb-6 font-semibold">
          Expert HVAC<br />
          <em className="not-italic text-luxury-gold">Services</em>
        </h1>

        <p className="font-sans text-base lg:text-lg text-white/50 leading-relaxed max-w-xl mb-10">
          Furnace installation, air conditioning, indoor air quality, and professional duct cleaning — delivered by T.S.S.A.-certified specialists across the GTA.
        </p>

        <div className="flex flex-col sm:flex-row gap-4">
          <a
            href="tel:9058454009"
            className="inline-flex items-center justify-center gap-3 bg-luxury-gold hover:bg-luxury-gold-light text-luxury-black font-caps font-bold text-xs tracking-[0.18em] uppercase px-9 py-4 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap shadow-gold"
          >
            <div className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-fill text-sm" /></div>
            <span>Call (905) 845-4009</span>
          </a>
          <Link
            to="/locations"
            className="inline-flex items-center justify-center gap-3 border border-white/25 hover:border-luxury-gold/60 text-white hover:text-luxury-gold font-caps text-xs tracking-[0.18em] uppercase px-8 py-4 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <span>View Service Areas</span>
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
